import * as React from "react";
import './SelectableCard.css';
import {ISelectableCard} from "./ISelectableCard";
import Icon from "../../Icon/Icon";
import {isMobile} from "react-device-detect";

interface IProps {
    data: ISelectableCard
}

export default class SelectableCard  extends React.Component<
    IProps
    > {
    public action: any;

    constructor(props: IProps) {
        super(props);
        this.action = props.data.click;
    }

    public render() {
        const {data} = this.props;
        return (
            <div className={"selectable-card-container"  + (data.isSelected ? " selected-card" : "") + (data.isSelected && isMobile ? " selected-card-mobile" : "") } onClick={this.action}>
                <div className="selectable-card-icon-container">
                    {data.isSelected? <Icon icon={"radioSelected"} />: null}
                    {data.isSelected? null : <Icon icon={"radio"} />}
                </div>
                <div className="selectable-card-text-container">
                    <div className="selectable-card-header"> {data.title}</div>
                    <div className="selectable-card-text"> {data.text}</div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/CardsSelect/SelectableCard/SelectableCard.tsx